import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { updateProduct } from "../services/productService";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../utils/getErrorMessage";


export const useUpdateProduct = (
  productId,
  formData,
  variations,
  bestSeller,
  status,
  images = [],
) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: async () => {
      const payload = new FormData();
      payload.append("title", formData.title);
      payload.append("product_category_id", formData.product_category_id);
      payload.append("price", formData.price);
      payload.append("gender", formData.gender);
      payload.append("quantity", formData.quantity);
      payload.append("description", formData.description);
      payload.append("best_seller", bestSeller);
      payload.append("active_status", status);
      if (formData.discount)
        payload.append("discount", parseInt(formData.discount, 10));

      // Only append new images (File or base64), skip existing (object with id)
      images.forEach((image, index) => {
        if (image instanceof File) {
          payload.append(`images[]`, image);
        } else if (typeof image === "string" && image.startsWith("data:")) {
          // Convert base64 to blob
          const arr = image.split(",");
          const mime = arr[0].match(/:(.*?);/)[1];
          const bstr = atob(arr[1]);
          const n = bstr.length;
          const u8arr = new Uint8Array(n);
          for (let i = 0; i < n; i++) {
            u8arr[i] = bstr.charCodeAt(i);
          }
          const blob = new Blob([u8arr], { type: mime });
          payload.append(`images[]`, blob, `image-${index}.jpg`);
        }
      });

      // Add variations
      variations.forEach((variation, vIdx) => {
        payload.append(`variations[${vIdx}][name]`, variation.name);
        variation.values.forEach((value, valueIdx) => {
          payload.append(`variations[${vIdx}][values][${valueIdx}]`, value);
        });
      });

      return updateProduct(productId, payload);
    },
    onSuccess: () => {
      toast.success("Product updated successfully!");
      queryClient.invalidateQueries({ queryKey: ["products"] });
      queryClient.invalidateQueries({ queryKey: ["product", productId] });
      navigate("/product");
    },
    onError: (error) => {
      toast.error(getErrorMessage(error, "Failed to update product."));
    },
  });

  return mutation;
};
